import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { LoginService } from 'app/services/auth/login.service';
import { AppShellLayoutService } from 'app/services/layout/app-shell-layout.service';

@Component({
  selector: 'app-verif-email',
  templateUrl: './verif-email.component.html',
  styleUrls: ['./verif-email.component.scss']
})
export class VerifEmailComponent implements  OnInit {
  displayPassword="password";
  public coreConfig: any;
  public loginForm: UntypedFormGroup;
  public loading = false;
  public submitted = false;
  public returnUrl: string;
  public error = '';
  data:any={ 
    token:"",
    
  }
  dataError:any={
          token:"",
       
  }
  countdown: number = 60;
interval: any;
canResend: boolean = false;
  validate=false;
  public passwordTextType: boolean;
errorMessage:any="";
  infoMessage = '';
  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(
    private loginService:LoginService,
    private _coreConfigService: CoreConfigService,
    private _formBuilder: UntypedFormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private _appShellLayout: AppShellLayoutService
  ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

 

 
  tokenVerif()
  {
    this.dataError.token="";
    this.loading=true;
    let user = localStorage.getItem('currentUser');
    let users = JSON.parse(user);
    const onboardingPassword = sessionStorage.getItem('registration_onboarding_password') || '';
    let dataSend: { token: string; email: string; password?: string } = {
      token: this.data.token,
      email: users.email,
    };
    if (onboardingPassword.length >= 6) {
      dataSend.password = onboardingPassword;
    }
    if(this.data.token.length>0 && this.data.token.length<10)
    {
       this.loginService.veriftoken(dataSend).subscribe({
            next: (data) => {
              if (data.message && data.message == 1) {
                this.dataError.token = 'Code incorrect';
              } else {
                this.dataError.token = '';
                users.is_active = true;
                delete users.token;
                localStorage.setItem('currentUser', JSON.stringify(users));
                const hasStations =
                  Array.isArray(users.stations) && users.stations.length > 0;
                if (hasStations) {
                  sessionStorage.removeItem('registration_onboarding_password');
                }
                if (hasStations) {
                  this._appShellLayout.restoreAfterAuthPages();
                }
                void this._router.navigate([
                  hasStations ? '/home' : '/create-station',
                ]);
              }
              this.loading = false;
            },
            error: (err) => {
              this.dataError.token =
                err?.error?.error || err?.error?.message || 'Vérification impossible. Réessayez.';
              this.loading = false;
            },
          });
          return;
    }else 
    {
      this.dataError.token="Code incorrecte";
      this.loading=false;
    }

        
        
  }

  
  ngOnInit(): void {
    sessionStorage.removeItem('registration_verification_code');
    sessionStorage.removeItem('registration_email_hint');
    try {
      const raw = localStorage.getItem('currentUser');
      if (raw) {
        const user = JSON.parse(raw);
        if (user?.token) {
          delete user.token;
          localStorage.setItem('currentUser', JSON.stringify(user));
        }
      }
    } catch {
      /* ignore */
    }

    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
     this.startCountdown();
  }
  startCountdown() {
  this.canResend = false;
  this.countdown = 60;

  this.interval = setInterval(() => {
    this.countdown--;
    if (this.countdown <= 0) {
      clearInterval(this.interval);
      this.canResend = true;
    }
  }, 1000);
}
resendCode() {
  let user = localStorage.getItem('currentUser');
  let users = JSON.parse(user);
  if (!this.canResend) return;
   this.loginService.verifemail({ email: users.email, id: users.id })
          .subscribe({
            next: () => {
              this.errorMessage = '';
              this.infoMessage = 'Un nouveau code vous a été envoyé par email.';
            },
            error: (err) => {
              this.infoMessage = '';
              this.errorMessage =
                err?.error?.error ||
                err?.error?.detail ||
                "Impossible de renvoyer le code.";
            },
          });

  this.startCountdown();
}



}
